const anchorAdsConfig = ['PHILIPPINES', 'MEXICO', 'EGYPT', 'GERMANY', 'UK', 'POLAND', 'ITALY', 'ALGERIA', 'UAE', 'CHILE', 'MALAYSIA', 'INDONESIA', 'TAIWAN']

const recommendedArticlesOemConfig = {
  oppo: [
    {
      country: 'INDONESIA',
      percent: 100
    },
    {
      country: 'MALAYSIA',
      percent: 100
    },
    {
      country: 'SINGAPORE',
      percent: 100
    },
    {
      country: 'THAILAND',
      percent: 100
    },
    {
      country: 'VIETNAM',
      percent: 100
    },
    {
      country: 'PHILIPPINES',
      percent: 100
    },
    {
      country: 'MEXICO',
      percent: 100
    }
  ],
  transsion: [
    {
      country: 'INDONESIA',
      percent: 100
    },
    {
      country: 'MALAYSIA',
      percent: 100
    },
    {
      country: 'SINGAPORE',
      percent: 100
    },
    {
      country: 'THAILAND',
      percent: 100
    },
    {
      country: 'VIETNAM',
      percent: 100
    },
    {
      country: 'PHILIPPINES',
      percent: 100
    }
  ],
  vivo: [
    {
      country: 'INDONESIA',
      percent: 100
    },
    {
      country: 'MALAYSIA',
      percent: 100
    },
    {
      country: 'SINGAPORE',
      percent: 100
    },
    {
      country: 'THAILAND',
      percent: 100
    },
    {
      country: 'VIETNAM',
      percent: 100
    },
    {
      country: 'PHILIPPINES',
      percent: 100
    }
  ],
  xiaomi: [
    {
      country: 'INDONESIA',
      percent: 100
    },
    {
      country: 'MALAYSIA',
      percent: 100
    },
    {
      country: 'SINGAPORE',
      percent: 100
    },
    {
      country: 'THAILAND',
      percent: 100
    },
    {
      country: 'VIETNAM',
      percent: 100
    },
    {
      country: 'PHILIPPINES',
      percent: 100
    }
  ],
  honor: [
    {
      country: 'INDONESIA',
      percent: 100
    },
    {
      country: 'MALAYSIA',
      percent: 100
    },
    {
      country: 'SINGAPORE',
      percent: 100
    },
    {
      country: 'THAILAND',
      percent: 100
    },
    {
      country: 'VIETNAM',
      percent: 100
    },
    {
      country: 'PHILIPPINES',
      percent: 100
    },
    {
      country: 'MEXICO',
      percent: 100
    }
  ],
  oemDefault: [
    {
      country: 'INDONESIA',
      percent: 100
    },
    {
      country: 'MALAYSIA',
      percent: 100
    },
    {
      country: 'SINGAPORE',
      percent: 100
    },
    {
      country: 'THAILAND',
      percent: 100
    },
    {
      country: 'VIETNAM',
      percent: 100
    },
    {
      country: 'PHILIPPINES',
      percent: 100
    }
  ]
};

const videoAdsCountryConfig = [
  {
    country: 'VIETNAM',
    videoAdsUrl: 'https://pubads.g.doubleclick.net/gampad/ads?iu=/22897154128/hk_kaik.ai_preroll_vn&description_url=http%3A%2F%2Fkaik.ai&tfcd=0&npa=0&sz=400x300%7C640x360%7C640x480&min_ad_duration=5000&max_ad_duration=30000&gdfp_req=1&unviewed_position_start=1&output=vast&env=vp&impl=s&correlator=&plcmt=2'
  },
  {
    country: 'MEXICO',
    videoAdsUrl: 'https://pubads.g.doubleclick.net/gampad/ads?iu=/22897154128/hk_kaik.ai_preroll_mx&description_url=http%3A%2F%2Fkaik.ai&tfcd=0&npa=0&sz=400x300%7C640x360%7C640x480&min_ad_duration=5000&max_ad_duration=30000&gdfp_req=1&unviewed_position_start=1&output=vast&env=vp&impl=s&correlator=&plcmt=2'
  },
  {
    country: 'PHILIPPINES',
    videoAdsUrl: 'https://pubads.g.doubleclick.net/gampad/ads?iu=/22897154128/hk_kaik.ai_preroll_ph&description_url=http%3A%2F%2Fkaik.ai&tfcd=0&npa=0&sz=400x300%7C640x360%7C640x480&min_ad_duration=5000&max_ad_duration=30000&gdfp_req=1&unviewed_position_start=1&output=vast&env=vp&impl=s&correlator=&plcmt=2'
  },
  {
    country: 'MALAYSIA',
    videoAdsUrl: 'https://pubads.g.doubleclick.net/gampad/ads?iu=/22897154128/hk_kaik.ai_preroll_my&description_url=http%3A%2F%2Fkaik.ai&tfcd=0&npa=0&sz=400x300%7C640x360%7C640x480&min_ad_duration=5000&max_ad_duration=30000&gdfp_req=1&unviewed_position_start=1&output=vast&env=vp&impl=s&correlator=&plcmt=2'
  },
  {
    country: 'POLAND',
    videoAdsUrl: 'https://pubads.g.doubleclick.net/gampad/ads?iu=/22897154128/hk_kaik.ai_preroll_pl&description_url=http%3A%2F%2Fkaik.ai&tfcd=0&npa=0&sz=400x300%7C640x360%7C640x480&min_ad_duration=5000&max_ad_duration=30000&gdfp_req=1&unviewed_position_start=1&output=vast&env=vp&impl=s&correlator=&plcmt=2'
  },
  {
    country: 'SPAIN',
    videoAdsUrl: 'https://pubads.g.doubleclick.net/gampad/ads?iu=/22897154128/hk_kaik.ai_preroll_es&description_url=http%3A%2F%2Fkaik.ai&tfcd=0&npa=0&sz=400x300%7C640x360%7C640x480&min_ad_duration=5000&max_ad_duration=30000&gdfp_req=1&unviewed_position_start=1&output=vast&env=vp&impl=s&correlator=&plcmt=2'
  },
  {
    country: 'THAILAND',
    videoAdsUrl: 'https://pubads.g.doubleclick.net/gampad/ads?iu=/22897154128/hk_kaik.ai_preroll_th&description_url=http%3A%2F%2Fkaik.ai&tfcd=0&npa=0&sz=400x300%7C640x360%7C640x480&min_ad_duration=5000&max_ad_duration=30000&gdfp_req=1&unviewed_position_start=1&output=vast&env=vp&impl=s&correlator=&plcmt=2'
  }
];

const kaikAi = {
  apiUrl: 'https://kaikai-now.sg.cosmose.co/kaikai-now-oem-api',
  webEventsUrl: 'https://kaikai-now.sg.cosmose.co/kaikai-now-oem-api',
  videoAdsUrl: 'https://pubads.g.doubleclick.net/gampad/ads?iu=/22897154128/hk_kaik.ai_preroll&description_url=http%3A%2F%2Fkaik.ai&tfcd=0&npa=0&sz=400x300%7C640x360%7C640x480&min_ad_duration=5000&max_ad_duration=30000&gdfp_req=1&unviewed_position_start=1&output=vast&env=vp&impl=s&correlator=&plcmt=2',
  assetsUrl: 'https://images-2.kaik.ai/assets/content',
  recommendedArticlesOemConfig,
  anchorAdsConfig,
  videoAdsCountryConfig,
};
const devKaikAi = {
  apiUrl: 'https://kaikai-now.dev.cosmose.cloud/kaikai-now-oem-api',
  webEventsUrl: 'https://kaikai-now.dev.cosmose.cloud/kaikai-now-oem-api',
  videoAdsUrl: 'https://pubads.g.doubleclick.net/gampad/ads?iu=/22897154128/hk_kaik.ai_preroll&description_url=http%3A%2F%2Fkaik.ai&tfcd=0&npa=0&sz=400x300%7C640x360%7C640x480&min_ad_duration=5000&max_ad_duration=30000&gdfp_req=1&unviewed_position_start=1&output=vast&env=vp&impl=s&correlator=&plcmt=2',
  assetsUrl: 'https://dev.kaik.ai/assets/content',
  recommendedArticlesOemConfig,
  anchorAdsConfig,
  videoAdsCountryConfig,
};
const preprodKaikAi = {
  apiUrl: 'https://kaikai-now.sg.cosmose.co/kaikai-now-oem-api',
  webEventsUrl: 'https://kaikai-now.sg.cosmose.co/kaikai-now-oem-api',
  videoAdsUrl: 'https://pubads.g.doubleclick.net/gampad/ads?iu=/22897154128/hk_kaik.ai_preroll&description_url=http%3A%2F%2Fkaik.ai&tfcd=0&npa=0&sz=400x300%7C640x360%7C640x480&min_ad_duration=5000&max_ad_duration=30000&gdfp_req=1&unviewed_position_start=1&output=vast&env=vp&impl=s&correlator=&plcmt=2',
  assetsUrl: 'https://images-2.kaik.ai/assets/content',
  recommendedArticlesOemConfig,
  anchorAdsConfig,
  videoAdsCountryConfig,
};
const localKaikAi = {
  apiUrl: 'https://kaikai-now.dev.cosmose.cloud/kaikai-now-oem-api',
  webEventsUrl: 'https://kaikai-now.dev.cosmose.cloud/kaikai-now-oem-api',
  videoAdsUrl: 'https://pubads.g.doubleclick.net/gampad/ads?iu=/22897154128/hk_kaik.ai_preroll&description_url=http%3A%2F%2Fkaik.ai&tfcd=0&npa=0&sz=400x300%7C640x360%7C640x480&min_ad_duration=5000&max_ad_duration=30000&gdfp_req=1&unviewed_position_start=1&output=vast&env=vp&impl=s&correlator=&plcmt=2',
  assetsUrl: 'https://dev.kaik.ai/assets/content',
  recommendedArticlesOemConfig,
  anchorAdsConfig,
  videoAdsCountryConfig,
};

function getConfig(domain) {
  const configMap = {
    'kaik.ai': kaikAi,

    'dev.kaik.ai': devKaikAi,
    'dev.in-kaik.ai': devKaikAi,
    'dev.aar-kaik.ai': devKaikAi,
    'dev.ecn-kaik.ai': devKaikAi,
    'dev.edn-kaik.ai': devKaikAi,
    'dev.tulh-kaik.ai': devKaikAi,

    'dev.jp-kaik.ai': devKaikAi,
    'dev.us-kaik.ai': devKaikAi,
    'dev.dae-kaik.ai': devKaikAi,
    'dev.ean-kaik.ai': devKaikAi,
    'dev.eas-kaik.ai': devKaikAi,
    'dev.fae-kaik.ai': devKaikAi,
    'dev.inkt-kaik.ai': devKaikAi,
    'dev.noal-kaik.ai': devKaikAi,
    'dev.paul-kaik.ai': devKaikAi,
    'dev.part-kaik.ai': devKaikAi,

    'dev.vokn-kaik.ai': devKaikAi,
    'dev.comn-kaik.ai': devKaikAi,
    'dev.moly-kaik.ai': devKaikAi,
    'dev.tiur-kaik.ai': devKaikAi,
    'dev.ebs-kaik.ai': devKaikAi,
    'dev.ebn-kaik.ai': devKaikAi,

    'preprod.kaik.ai': preprodKaikAi,
    'localhost:4201': localKaikAi,
    'localhost:3000': localKaikAi,
  };
  return configMap[domain] ?? kaikAi;
}

window.config = getConfig(document.location.host);

function getQueryParams() {
  const params = {};
  const queryString = window.location.search.slice(1);
  const pairs = queryString.split('&');

  pairs.forEach(pair => {
    const [key, value] = pair.split('=');
    params[key] = value;
  });

  return params;
}
